'use strict';

import { View } from '../vendor/kerneljs';

const Sticky = View.extend({
	initialize: function(){
		this.calculateOffset();
		this.calculateScrollFix();
		window.addEventListener('resize', this.handleResize.bind(this));

		let notificationArea = document.querySelector('.notifications');
		if (notificationArea) {
			let observer = new MutationObserver(this.handleResize.bind(this));
			observer.observe(notificationArea, {childList: true});
		}
	},

	handleResize: function() {
		this.calculateOffset();
		this.calculateScrollFix.bind(this);
	},

	calculateOffset: function() {
		let siteHeader = document.querySelector('header.site-header');
		this.scrollOffset = siteHeader.offsetHeight + siteHeader.offsetTop;
	},

	calculateScrollFix: function() {
		if (window.screen.width >= 950) {
			this.wrapper = this.el;
			this.offset = this.wrapper.offsetHeight;
			this.main = document.querySelector('main');
			window.addEventListener('scroll', this.handleScroll.bind(this));
		} else {
			window.removeEventListener('scroll', this.handleScroll.bind(this));
		}
	},

	handleScroll: function(e) {
		if (window.scrollY >= this.scrollOffset) {
			this.wrapper.setAttribute('style', 'position: fixed !important;')
			this.main.setAttribute('style',"margin-top: " + this.offset + "px");
		}
		else {
			this.wrapper.setAttribute('style','position: relative;');
			this.main.setAttribute('style',"margin-top: 0px");
		}
	}
});

export default Sticky;
